import { Button } from 'react-bootstrap'
import { AssinaturaType, ButtonType, OptionsHelper, showError } from '../../../_metronic/helpers'
import { FormSelect, IOption, useModal } from '../../components'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { FC } from 'react'
import { saveTipoCert } from '../../modules/auth'

const validationSchema = Yup.object().shape({
  certificado: Yup.object().nullable().required('Selecione um tipo de certificado'),
})

type IProps = {
  onSubmit: (value: AssinaturaType) => void
}

export const CertificadoModal: FC<IProps> = ({ onSubmit }) => {
  const { closeModal } = useModal()

  const formik = useFormik({
    initialValues: {
      certificado: undefined as IOption<AssinaturaType> | undefined,
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        saveTipoCert(values.certificado?.value as AssinaturaType)
        onSubmit(values.certificado?.value as AssinaturaType)
        closeModal()
      } catch (error) {
        showError(error)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormSelect
        name='certificado'
        formik={formik}
        fetchOptions={OptionsHelper.getOptionsTiposAssinatura}
        label='Certificado'
        placeholder='Selecione um tipo de certificado'
        isRequired
      />

      <div className='d-flex justify-content-center mt-10'>
        <Button type={ButtonType.Submit} className='btn-primary'>
          Enviar
        </Button>
      </div>
    </form>
  )
}
